import { EDITOR_TOGGLE_ASSET_UPLOD } from './constants';

export function toggleAssetUplod() {
  return {
    type: EDITOR_TOGGLE_ASSET_UPLOD,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_ASSET_UPLOD:
      return {
        ...state,
        toggleAsset: !state.toggleAsset,
        showBuilderCanvasLoader: false,
      };

    default:
      return state;
  }
}
